import { render, staticRenderFns } from "./NotificationLaboratoriesApprovalRequestForm.vue?vue&type=template&id=4776ced9"
import script from "./NotificationLaboratoriesApprovalRequestForm.vue?vue&type=script&lang=js"
export * from "./NotificationLaboratoriesApprovalRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports